import template from './client-select.html'

const ClientSelectComponent = {
    bindings: {
        clientList: '<'
    },
    template,
};

export default ClientSelectComponent;



// WEBPACK FOOTER //
// ./app/components/facility-reporting/client-select/client-select-component.js